import React, { Component } from 'react';

export default function Unauthorised() {
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    height: '100%',
                    // backgroundColor: 'lightgray',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div>
                    {/* <p>Looks like you have reached a page you are not supposed to see!!</p> */}
                    <img src="/images/403.jpg"></img>
                </div>
            </div>
        </>
    );
}
